
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProcessMasterGrid extends _Ext.GridBase<ProcessMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ProcessMaster'; }
        protected getDialogType() { return ProcessMasterDialog; }
        protected getIdProperty() { return ProcessMasterRow.idProperty; }
        protected getInsertPermission() { return ProcessMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return ProcessMasterRow.localTextPrefix; }
        protected getService() { return ProcessMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
    }
}